import React, {Fragment, Component} from 'react';
import PropTypes from 'prop-types';

import TweenLite from "gsap/TweenLite";
import {Back} from "gsap";
import {inject, observer} from "mobx-react";

import './ForecastPane.scss';
import ForecastGraph from "./ForecastGraph";

const nFormatter = (num, digits) => {
    let isNegative = false;
    if (num < 0) {
        isNegative = true;
        num *= -1;
    }
    const si = [
        {value: 1, symbol: ""},
        {value: 1E3, symbol: "k"},
        {value: 1E6, symbol: "M"},
        {value: 1E9, symbol: "B"},
        {value: 1E12, symbol: "T"},
        {value: 1E15, symbol: "P"},
        {value: 1E18, symbol: "E"}
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
            break;
        }
    }

    if (isNegative) {
        num *= -1;
    }

    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
};

@observer
class ForecastPane extends Component {

    constructor(props) {
        super(props);

        this.state = {
            migrantInflux: 0,
        };
    }

    onChange = (e) => {

        const {name, value} = e.target;

        this.setState({
            [name]: value,
        });
    };

    handleFocus = (event) => {
        const el = event.target.parentElement;
        const an = el.children[0];

        TweenLite.to(an, 0.1, {y: 0, autoAlpha: 1});
    };

    handleBlur = (event) => {
        const el = event.target.parentElement;
        const an = el.children[0];

        TweenLite.to(an, 0.075, {y: 5, autoAlpha: 0, ease: Back.linear, delay: 0.025});
    };

    onForecast = e => {
        e.preventDefault();

        const migrantInflux = document.getElementById('migrantInflux').value;
        this.props.forecast(migrantInflux);
        this.setState({
            migrantInflux: 0
        })
    };

    render() {

        const {attemptsLeft, closePane, hasGameStarted, forecastRequestSent, metrics, forecastData, world, minInflux, maxInflux} = this.props;

        const {cost, discord, employ, favorability, gdp, hrt, eqt} = metrics.metrics;
        const {a0AllInCountry, b0AllInCountry, c0AllInCountry, d0AllInCountry,} = world.world;

        const currentRefugeeData = {
            a0AllInCountry,
            b0AllInCountry,
            c0AllInCountry,
            d0AllInCountry,
            totPop: a0AllInCountry + b0AllInCountry + c0AllInCountry + d0AllInCountry
        };

        const forecastRefugeeData = {
            a0AllInCountry: forecastData.a0,
            b0AllInCountry: forecastData.b0,
            c0AllInCountry: forecastData.c0,
            d0AllInCountry: forecastData.d0,
            totPop: forecastData.totPop,
        };

        // console.log("Attempts left: ", attemptsLeft)

        return (
            <Fragment>
                <div className="close-article" onClick={closePane}/>
                <div className="dash__inner p4 relative">
                    <h3>Forecast Pane</h3>

                    <div className="container">
                        <form
                            className="signup_form"
                            method="post"
                            onSubmit={this.onForecast}
                        >
                            <p>Enter the number of refugees expected to flee Kyapera over the next year</p>
                            <div className={`flex flex-wrap formRow`}>
                                <input
                                    id="migrantInflux"
                                    name="migrantInflux"
                                    className={`input__one account__input`}
                                    type="number"
                                    step="100"
                                    value={this.state.migrantInflux}
                                    required="required"
                                    onChange={e => this.onChange(e)}
                                />
                            </div>
                            <em>Expected refugees
                                between {parseInt(minInflux).toLocaleString()} and {parseInt(maxInflux).toLocaleString()}</em>
                            <br/>
                            <br/>
                            <button
                                type="submit"
                                className="policyBtn button"
                                disabled={!hasGameStarted ? 'disabled' : (parseInt(attemptsLeft) > 0 ? (forecastRequestSent ? 'disabled' : false) : 'disabled')}>
                                {forecastRequestSent ? 'Forecasting . . .' : (parseInt(attemptsLeft) > 0 ? 'Forecast' : 'Out of forecast attempts')}
                            </button>
                            <p>Attempts remaining (for your country):
                                <span className="ml1"><strong>{attemptsLeft}</strong></span>
                            </p>

                        </form>
                    </div>

                    <div className="flex flex-grid-2 bb1">

                        <div className="container">
                            <ForecastGraph title={"Migrants now in the country"}
                                           data={currentRefugeeData}/>
                        </div>

                        <div className="container">
                            <ForecastGraph title={"Predicted migrants in the country"}
                                           data={forecastRefugeeData}/>
                        </div>

                    </div>

                    <br/>

                    <table className="polTable">
                        <thead>
                        <tr>
                            <th>Metric</th>
                            <th>Current</th>
                            <th>Predicted</th>
                        </tr>
                        </thead>
                        <tbody className="align-r">
                        <tr>
                            <td className="align-c">Cost</td>
                            <td>${cost[cost.length - 1] && nFormatter(cost[cost.length - 1], 1)}</td>
                            <td>${nFormatter(forecastData.cost, 1)}</td>
                        </tr>
                        <tr>
                            <td className="align-c">Discord</td>
                            <td>{discord[discord.length - 1] && discord[discord.length - 1].toFixed(2).toLocaleString()}</td>
                            <td>{forecastData.discord.toFixed(2).toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td className="align-c">Employment %</td>
                            <td>{employ[employ.length - 1] && employ[employ.length - 1].toFixed(2).toLocaleString()}</td>
                            <td>{forecastData.employ.toFixed(2).toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td className="align-c">Favorability</td>
                            <td>{favorability[favorability.length - 1] && favorability[favorability.length - 1].toFixed(2).toLocaleString()}</td>
                            <td>{forecastData.favorability.toFixed(2).toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td className="align-c">GDP</td>
                            <td>{gdp[gdp.length - 1] && gdp[gdp.length - 1].toFixed(2).toLocaleString()}</td>
                            <td>{forecastData.gdp.toFixed(2).toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td className="align-c">HRX</td>
                            <td>{hrt[hrt.length - 1] && hrt[hrt.length - 1].toFixed(2).toLocaleString()}</td>
                            <td>{forecastData.hrt.toFixed(2).toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td className="align-c">Equity</td>
                            <td>{eqt[eqt.length - 1] && eqt[eqt.length - 1].toFixed(2).toLocaleString()}</td>
                            <td>{forecastData.eqt.toFixed(2).toLocaleString()}</td>
                        </tr>
                        </tbody>
                    </table>

                </div>
            </Fragment>
        )
    }
}

ForecastPane.propTypes = {
    closePane: PropTypes.func.isRequired,
    forecast: PropTypes.func.isRequired,
    forecastRequestSent: PropTypes.bool.isRequired,
    hasGameStarted: PropTypes.bool.isRequired,
    attemptsLeft: PropTypes.number,
    forecastData: PropTypes.object.isRequired,
    minInflux: PropTypes.number,
    maxInflux: PropTypes.number,
};

export default inject('metrics', 'world')(ForecastPane);
